import { PapiUser } from '@wix/da-papi-types';
import { createAction } from 'redux-actions';
import { createCallbackActionCreator } from '../../Stream/helpers';
import { actionTypePrefix } from './constants';

export const blockUser = createAction(
  `${actionTypePrefix}.BLOCK_USER`,
  (user: PapiUser, dispatchAction: any) => ({ user, dispatchAction })
);
export const blockUserAndRedirect = createAction(
  `${actionTypePrefix}.BLOCK_USER_AND_REDIRECT`,
  (user: PapiUser, redirectLocation: string) => ({
    user,
    redirectLocation,
  })
);
export const blockUserSuccess = createAction(
  `${actionTypePrefix}.BLOCK_USER_SUCCESS`,
  (userId: number) => userId
);
export const blockUserFail = createAction(
  `${actionTypePrefix}.BLOCK_USER_FAIL`,
  (user: PapiUser, result) => ({ user, result })
);

export const unblockUser = createAction(
  `${actionTypePrefix}.UNBLOCK_USER`,
  (userId: number) => userId
);

export const unblockUserSuccess = createAction(
  `${actionTypePrefix}.UNBLOCK_USER_SUCCESS`,
  (userId: number) => userId
);

export const unblockUserFail = createAction(
  `${actionTypePrefix}.UNBLOCK_USER_FAIL`,
  (userId: number) => userId,
  (userId, result) => result
);

export const searchFriendsWithOptions = createAction(
  `${actionTypePrefix}.SEARCH_FRIENDS`,
  (
    query: string,
    callback: (results: PapiUser[]) => void,
    options: {
      isChatContext?: boolean;
      includeNonFriendExactMatch?: boolean;
      userType?: 'both' | 'group' | 'deviant';
      excludeBanned?: boolean;
    }
  ) => ({
    query,
    callback,
    isChatContext: options.isChatContext,
    includeNonFriendExactMatch: options.includeNonFriendExactMatch ?? true,
    userType: options.userType ?? 'both',
    excludeBanned: options.excludeBanned ?? false,
  })
);

export const searchFriends = (query: string, callback: (results: PapiUser[]) => void) =>
  searchFriendsWithOptions(query, callback, {
    includeNonFriendExactMatch: false,
    userType: 'deviant',
  });

export const initializeFriendList = createAction(`${actionTypePrefix}.FRIENDS_INIT`, streamId => ({
  streamId,
}));

export const fetchMoreFriends = createCallbackActionCreator(`${actionTypePrefix}.FETCH_FRIENDS`);

export const fetchMoreSupporters = createCallbackActionCreator(
  `${actionTypePrefix}.FETCH_SUPPORTERS`
);
